"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualCareComponent = void 0;
var react_1 = __importStar(require("react"));
var CareFirstBanner_png_1 = __importDefault(require("../../../../assets/CareFirstBanner.png"));
var VirtualCareComponent = function () {
    (0, react_1.useEffect)(function () { }, []);
    return (react_1.default.createElement("div", { className: "flex flex-col relative items-center px-0 md:h-[450px] h-[250px]" },
        react_1.default.createElement("img", { className: "h-full w-full md:object-cover object-contain absolute rounded-lg -z-20", src: CareFirstBanner_png_1.default })));
};
exports.VirtualCareComponent = VirtualCareComponent;
